import PulseLoader from "react-spinners/PulseLoader";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useGetTaskBasesQuery } from "../taskBasesApiSlice";

const _ActionsList = () => {
  const { taskBaseId, groupId, type } = useParams();

  const { taskBase } = useGetTaskBasesQuery("taskBasesList", {
    selectFromResult: ({ data }) => {
        return {
            taskBase: data?.find(x=>x._id ===taskBaseId)
        }
    },
})
if(!taskBase) return <span>Loading actions</span>
  let content = <h1>No actions</h1>;
const actions = taskBase.actions
  const tableContent =actions.map((action) => {
      const cellStatus = action.active ? "" : "table__cell--inactive";

      return (
        <tr key={action._id} className={`table__row`}>
          <td className={`table__cell ${cellStatus}`}>
            {" "}
            {action.title} <hr /> <small> {action.text}</small>
          </td>
          {/* <td className="table__cell edit-action__type">{action.type}</td> */}
          <td className={`table__cell ${cellStatus}`}>
            <Link
              className="icon-button table__button"
              to={`/${type}/${groupId}/task-bases/${taskBaseId}/actions/${action._id}`}
            >
              <FontAwesomeIcon icon={faPenToSquare} />
            </Link>
          </td>
        </tr>
      );
    });

  content = (
    <>
      <table className="table table--edit-actions">
        <thead className="table__thead">
          <tr>
            <th
              scope="col"
              className="table__th edit-action__text th-with-buttons"
            >
              <span>דרישות</span>
              <Link
                className="table__button"
                to={`/${type}/${groupId}/task-bases/${taskBaseId}/actions/new`}
              >
                <FontAwesomeIcon icon={faAdd} />
                הוספת דרישה
              </Link>
            </th>
            {/* <th scope="col" className="table__th edit-action__type">סוג</th> */}
            <th scope="col" className="table__th edit-action__edit">
              #
            </th>
          </tr>
        </thead>
        <tbody>{tableContent}</tbody>
      </table>
    </>
  );


  return content;
};
export default _ActionsList;
